import React from "react";
import { Routes, Route } from "react-router-dom";
// Import module components
import Company from "./app/Company/index.js";
import CompanyDetail from "./app/NewCompany/CompanyDetail/index.jsx";
import AddCompanyNew from "./app/NewCompany/AddCompany/index.jsx";
import AddFranchise from "./app/NewCompany/AddFranchise/index.jsx";
import FranchiseDetail from "./app/NewCompany/EditFranchise/index.jsx";
import AddEquity from "./app/NewCompany/AddEquity/index.jsx";
import AddDebt from "./app/NewCompany/AddDebt/index.jsx";
import EquityDetail from "./app/NewCompany/EditEquity/index.jsx";
import DebtDetail from "./app/NewCompany/EditDebt/index.jsx";

import Product from "./app/Product/index.js";
import ProductDetail from "./app/ProductDetail/index.js";
import AddProduct from "./app/AddProduct/index.jsx";
import AddService from "./app/AddService/index.js";

import Ambition from "./app/Ambition/index.js";
import AmbitionDetail from "./app/AmbitionDetail/index.js";
import OurCompany from "./app/Ambition/OurCompany/index.js";
import ESGmain from "./app/Ambition/ESG/ESGmain.js";
import SDGmain from "./app/Ambition/SDG/SDGmain.js";
import EUGreenDeal from "./app/Ambition/EUGreenDeal/EUGreenDeal.js";
import SBTi from "./app/Ambition/SBTi/index.js";
import RoleAmbition from "./app/RoleAmbition/index.js";
import PartnershipsList from "./app/SolutionsLab/PartnershipsList/PartnershipsList.jsx";
import PartnershipDetail from "./app/SolutionsLab/PartnershipDetail/PartnershipDetail.jsx";

import Reporting from "./app/Reporting/index.js";
import Output from "./app/Reporting/Output/index.js";

import WasteMap from "./app/WasteMap/index.js";

import Feed from "./app/Feed/Feed.js";

import Education from "./app/NewEducation/index.jsx";
import CourseDetail from "./app/NewEducation/CourseDetail.jsx";
import ClassPage from "./app/NewEducation/MyCourses/ClassPage.jsx";
import ReadMoreDetail from "./app/NewEducation/ReadMoreDetail.jsx";

import AdminDash from "./app/AdminDash/index.jsx";

import Client from "./app/Client/index.jsx";

import Share from "./app/Share/index.jsx";

// Action Plan Routes
import PurchaseActionPlan from "./app/Ambition/ActionPlansDetail/PurchasingActionPlans/index.jsx";
import ProductionActionPlan from "./app/Ambition/ActionPlansDetail/ProductionActionPlans/index.jsx";
import MarketingActionPlan from "./app/Ambition/ActionPlansDetail/MarketingActionPlans/index.jsx";
import LogisticActionPlan from "./app/Ambition/ActionPlansDetail/LogisticActionPlans/index.jsx";
import CustomActionPlan from "./app/Ambition/ActionPlansDetail/CustomActionPlans/index.jsx";

export const CompanyRoutes = () => {
  return (
    <Routes>
      <Route index element={<Company />} />
      <Route path=":businessId" element={<CompanyDetail />} />
      <Route path="add" element={<AddCompanyNew />} />
      <Route path="add-franchise" element={<AddFranchise />} />
      <Route path="add-equity" element={<AddEquity />} />
      <Route path="add-debt" element={<AddDebt />} />
      <Route path="franchise/:franchiseId" element={<FranchiseDetail />} />
      <Route path="equity/:equityId" element={<EquityDetail />} />
      <Route path="debt/:debtId" element={<DebtDetail />} />
    </Routes>
  );
};

export const ProductRoutes = () => {
  return (
    <Routes>
      <Route index element={<Product />} />
      <Route path=":productId" element={<ProductDetail />} />
      <Route path="add" element={<AddProduct />} />
      <Route path="service/add" element={<AddService />} />
      <Route path="service/:productId" element={<ProductDetail />} />
    </Routes>
  );
};

export const AmbitionRoutes = () => {
  return (
    <Routes>
      <Route index element={<Ambition />} />
      <Route path="ourcompany" element={<OurCompany />} />
      <Route path=":id" element={<AmbitionDetail />} />
      <Route path="roles/:role" element={<RoleAmbition />} />
      <Route path="esg/:businessName" element={<ESGmain />} />
      <Route path="sdg/:businessName" element={<SDGmain />} />
      <Route path="eugreendeal/:businessName" element={<EUGreenDeal />} />
      <Route path="sbti/:businessName" element={<SBTi />} />
      <Route path="partnership/:tabName" element={<PartnershipsList />} />
      <Route path="partnership/:tabName/:id" element={<PartnershipDetail />} />

      {/* Action Plan Routes with Year and Department Parameters */}
      <Route
        path="purchase-action-plan/:year/:departmentId"
        element={<PurchaseActionPlan />}
      />
      <Route
        path="production-action-plan/:year/:departmentId"
        element={<ProductionActionPlan />}
      />
      <Route
        path="marketing-action-plan/:year/:departmentId"
        element={<MarketingActionPlan />}
      />
      <Route
        path="logistic-action-plan/:year/:departmentId"
        element={<LogisticActionPlan />}
      />
      <Route
        path="custom-action-plan/:departmentName/:year/:departmentId"
        element={<CustomActionPlan />}
      />
    </Routes>
  );
};

export const ReportingRoutes = () => {
  return (
    <Routes>
      <Route index element={<Reporting />} />
      <Route path="output" element={<Output />} />
    </Routes>
  );
};

export const MapRoutes = () => {
  return (
    <Routes>
      <Route index element={<WasteMap />} />
    </Routes>
  );
};

export const FeedRoutes = () => {
  return (
    <Routes>
      <Route index element={<Feed />} />
    </Routes>
  );
};

export const EducationRoutes = () => {
  return (
    <Routes>
      <Route index element={<Education />} />
      <Route path="/courses/:courseId" element={<CourseDetail />} />
      <Route path="/class/:classItemId" element={<ClassPage />} />
      <Route path="/classes" element={<ReadMoreDetail />} />
    </Routes>
  );
};

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route index element={<AdminDash />} />
    </Routes>
  );
};

export const ClientRoutes = () => {
  return (
    <Routes>
      <Route index element={<Client />} />
    </Routes>
  );
};

export const ShareRoutes = () => {
  return (
    <Routes>
      <Route index element={<Share />} />
    </Routes>
  );
};
